import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { ProtectiveAdvancesStore } from '../stores/protectiveAdvancesStore';

export const useProtectiveAdvancesStore = () =>
  useContext<{
    protectiveAdvancesStore: ProtectiveAdvancesStore;
  }>(StoreContext);
